/**
 * Trade Service
 * Handles all trade-related API calls
 */

import { apiGet } from './apiClient';
import API_CONFIG from './apiConfig';

/**
 * Get all user trades
 * @returns {Promise}
 */
export const getAllTrades = async () => {
  return apiGet(API_CONFIG.endpoints.trades);
};

/**
 * Get specific trade details by ID
 * @param {string} tradeId - Trade ID
 * @returns {Promise}
 */
export const getTradeById = async (tradeId) => {
  return apiGet(API_CONFIG.endpoints.tradeById(tradeId));
};

/**
 * Get user's forex trades
 * @param {Object} params - Query parameters (status, page, limit, sortBy, sortOrder)
 * @returns {Promise}
 */
export const getForexTrades = async (params = {}) => {
  const queryString = buildQueryString(params);
  const endpoint = queryString 
    ? `${API_CONFIG.endpoints.forexTrades}?${queryString}`
    : API_CONFIG.endpoints.forexTrades;
  return apiGet(endpoint);
};

/**
 * Get user's cryptocurrency trades
 * @param {Object} params - Query parameters (status, page, limit, sortBy, sortOrder)
 * @returns {Promise}
 */
export const getCryptoTrades = async (params = {}) => {
  const queryString = buildQueryString(params);
  const endpoint = queryString 
    ? `${API_CONFIG.endpoints.cryptoTrades}?${queryString}`
    : API_CONFIG.endpoints.cryptoTrades;
  return apiGet(endpoint);
};

/**
 * Get user's gold trades
 * @param {Object} params - Query parameters (status, page, limit, sortBy, sortOrder)
 * @returns {Promise}
 */
export const getGoldTrades = async (params = {}) => {
  const queryString = buildQueryString(params);
  const endpoint = queryString 
    ? `${API_CONFIG.endpoints.goldTrades}?${queryString}`
    : API_CONFIG.endpoints.goldTrades;
  return apiGet(endpoint);
};

/**
 * Build query string from params object
 * @param {Object} params - Query parameters
 * @returns {string}
 */
const buildQueryString = (params) => {
  const queryParams = new URLSearchParams();
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
      queryParams.append(key, params[key]);
    }
  });
  return queryParams.toString();
};

/**
 * Get user's active trades
 * @returns {Promise}
 */
export const getActiveTrades = async () => {
  return apiGet(API_CONFIG.endpoints.activeTrades);
};

/**
 * Get user's trade history
 * @returns {Promise}
 */
export const getTradeHistory = async () => {
  return apiGet(API_CONFIG.endpoints.tradeHistory);
};

/**
 * Get user's trade statistics
 * @returns {Promise}
 */
export const getTradeStats = async () => {
  return apiGet(API_CONFIG.endpoints.tradeStats);
};

